import type { TableSqlTransparency } from '../../../../../schemas/query/tree.ts'
import type { ViewConfigTreeNode } from '../../../../../schemas/view_config/index.ts'
import type { CompileContext } from '../../../common.ts'
import { generateTableSqlForBlockFilter } from './generateTableSqlForBlockFilter.ts'

export interface GeneratedTableSql {
  tableSql: string
  tableSqlTransparency: TableSqlTransparency
}

/**
 * "tableSql"の生成
 * - "node.override.tableSql"が存在する場合はそれを優先して返す
 * - ブロックフィルタで参照カラムに対してのフィルタが設定された場合は新規に生成して返す
 */
export const generateTableSql = (node: ViewConfigTreeNode, context: CompileContext): GeneratedTableSql | undefined => {
  const before = node.override?.tableSql
  if (before !== undefined) {
    return { tableSql: before, tableSqlTransparency: 'opaque' }
  }
  if (node.additionalJoinOn === undefined) return
  // 2026/04 シートで"override.tableSql"を使用するケースは、今の実装だと存在しないため、処理の競合はない
  const { additionalJoinOn, modelName } = node
  const tableSql = generateTableSqlForBlockFilter({ additionalJoinOn, modelName, context })
  return tableSql === undefined ? undefined : { tableSql, tableSqlTransparency: 'transparent' }
}
